import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  CircularProgress,
  Divider,
  IconButton,
  Tooltip,
  Fab,
  useTheme,
} from "@mui/material";
import {
  AddComment as AddCommentIcon,
  Refresh,
  Close as CloseIcon,
} from "@mui/icons-material";

import ConversationList from "../../../components/ConversationList";

const ConversationListPane = ({
  isMobile,
  containerStyle,
  conversations,
  selectedConversation,
  onSelectConversation,
  fetchNextPage,
  refetchConversations,
  hasNextPage,
  isFetchingNextPage,
  isFetching,
  initialLoading,
  searchTerm,
  setSearchTerm,
  filters,
  setFilters,
  isLoadingDetails,
  onClose,
  onNewConversation,
  isCreatingConversation,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("chat");

  return (
    <Box
      className="tour-chat-list-pane"
      width={isMobile ? "100%" : "25%"}
      bgcolor={theme.palette.background.default}
      display="flex"
      flexDirection="column"
      height="100%"
      sx={containerStyle}
    >
      {!isMobile && (
        <>
          <Box
            className="tour-chat-list-toolbar"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            p={0.5}
            bgcolor={theme.palette.background.paper}
            sx={{ height: "62px" }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
            <Tooltip title={t("listPane.refreshRequests")}>
              <IconButton onClick={refetchConversations}>
                <Refresh />
              </IconButton>
            </Tooltip>
            <Tooltip title={isCreatingConversation ? t("listPane.creating") : t("listPane.newRequest")}>
              <span>
                <Fab
                  color="primary"
                  size="small"
                  sx={{ margin: 1 }}
                  onClick={onNewConversation}
                  disabled={isCreatingConversation}
                >
                  {isCreatingConversation ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    <AddCommentIcon />
                  )}
                </Fab>
              </span>
            </Tooltip>
          </Box>
          <Divider />
        </>
      )}

      <ConversationList
        conversations={conversations}
        selectedConversation={selectedConversation}
        onSelectConversation={onSelectConversation}
        fetchNextPage={fetchNextPage}
        refetchConversations={refetchConversations}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isFetching={isFetching}
        initialLoading={initialLoading}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        filters={filters}
        setFilters={setFilters}
        isLoadingDetails={isLoadingDetails}
      />
    </Box>
  );
};

export default ConversationListPane;
